import React from 'react'
import Button from '../../../components/atoms/Button/Button'
import Link from 'next/link'
import { Trans } from '../../../components/index'
import useTrans from '../../../hooks/useTrans'
import { useRouter } from 'next/router'
import { getAltText } from '../../../utils/safe'

const CatalogoPersonalizzatoTemplate = ({ page, utente, onClick }) => {
  const t = useTrans()
  const router = useRouter()

  return (
    <div className="catalogo-personalizzato">
      <div className="w-container">
        <div className="catalogo-personalizzato__cols">
          <div className="catalogo-personalizzato__image-content">
            <div className="catalogo-personalizzato__image-wrap">
              <div className="catalogo-personalizzato__image-box">
                <img
                  src={page?.main_image?.url}
                  alt={getAltText(page?.main_image)}
                />
              </div>
              <div className="catalogo-personalizzato__image-caption">
                <Trans chiave="Il tuo catalogo personalizzato come lo desideri tu" />
                {'!'}
              </div>
            </div>
          </div>
          <div className="catalogo-personalizzato__content">
            <h2 className="catalogo-personalizzato__title">
              <Trans chiave="Catalogo personalizzato" />
            </h2>
            <p>
              <Trans chiave="Ordina il tuo catalogo personalizzato" />
            </p>
            <p>
              <strong>
                <Trans chiave="STANDARD" />
                {':'}
              </strong>{' '}
              <Trans chiave="cover standard Sipec. Nessun minimo di acquisto" />
              {'.'}
            </p>
            <p>
              <strong>
                <Trans chiave="BASIC" />
                {':'}
              </strong>{' '}
              <Trans
                chiave="cover Sipec con logo e indirizzo del cliente stampati sulla
              copertina"
              />
              {'.'} <Trans chiave="Minimo d'acquisto 100 pezzi" />
              {'.'}
            </p>
            <p>
              <strong>
                <Trans chiave="SMART" />
                {':'}
              </strong>{' '}
              <Trans
                chiave="Cover personalizzata a scelta tra le nostre proposte con logo e
              indirizzo del cliente stampati sulla copertina"
              />
              {'.'} <Trans chiave="Minimo d'acquisto 250 pezzi" />
              {'.'}
            </p>
            <p>
              <strong>
                <Trans chiave="PREMIUM" />
                {':'}
              </strong>{' '}
              <Trans chiave="cover propria fornita dal cliente, interamente personalizzata" />
              {'.'} <Trans chiave="Minimo d'acquisto 250 pezzi" />
              {'.'}
            </p>
            <Link href={utente ? `/${router.locale}/richiesta-catalogo` : ''}>
              <a>
                <Button
                  label={t('Richiedi catalogo')}
                  size="medium"
                  variant="primary"
                  className="catalogo-personalizzato__cta"
                  onClick={onClick}
                />
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CatalogoPersonalizzatoTemplate
